<template>
  <div class="registerManagement" style="margin-top: 10px;width: 1440px;margin:0 auto;">
    <el-row justify="center" type="flex">
      <el-col >
        <div style="font-size:16px;color: #909399;margin-top:16px;margin-bottom:20px;">List of Registered personnel</div>
        <el-table v-loading="pieLoading"
          :data="gridData.slice((currentPage-1)*pageSize,currentPage*pageSize)">
          <el-table-column prop="userName" label="User Name" align="center"></el-table-column>
          <el-table-column prop="email" label="Email"  align="center"></el-table-column>
          <el-table-column prop="registerTime" label="Register Time"  align="center">
            <template  slot-scope="scope">
              <p>{{scope.row.registerTime | timefilters}}</p>
            </template>
          </el-table-column>
          <el-table-column label="Operate" align="center">
            <template slot-scope="scope">
              <el-button  title="Pass" type="primary" icon="el-icon-circle-check" circle  @click="handlePass(scope.$index,scope.row)"></el-button>
              <el-button  title="Delete" type="danger" icon="el-icon-delete" circle   @click="handleDelete(scope.$index,scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination 
          background
          layout="total,prev,pager,next"
          :total="gridData.length"
          :page-count="Math.ceil(gridData.length/pageSize)"
          :current-page.sync="currentPage"
          @current-change ="currentPageChange"
          :page-size = "pageSize">
        </el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="Assign Roles" align="left" :visible.sync="dialogVisible" width="350px" :close-on-click-modal ="false">
      <span>UserType</span>
      <el-select v-model="roleType">
        <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.name"
        >
        </el-option>
      </el-select>
      <div style="margin-top:20px;text-align:center;">
        <el-button type="primary" @click="passEvent">Sure</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
    export default {
      name: "registerManagement",
      filters:{
        timefilters(val){
          if(val == null || val == ''){
            return ''
          }else{
            let d = new Date(val);
            let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() +1 ) : d.getMonth() + 1;
            let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
            let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
            let min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
            let sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
            let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
            return times;
          }
        }
      },
      data(){
          return {
            pieLoading:false,
            pageSize:7,
            currentPage:1,
            gridData: [],
            dialogVisible:false,
            options:[],
            roleType:'user',
            selectID:null
          }
      },
      mounted(){
          this.query();
          this.getUserType();
      },
      methods:{
        //表格数据
        query:function () {
            this.$axios({ 
              method:'get',
              url:'/hlsTS/hlsii/admin/getAllRegisters'
            }).then((response) => {
              this.gridData = response.data
            }).catch(() => {
              this.gridData = []
            })
        },
        getUserType:function(){
          this.$axios({ 
              method:'get',
              url:'/hlsTS/hlsii/admin/getAllRoleInfo'
            }).then((response) => {
              this.options = response.data
            }).catch(() => {
              this.options = []
            })
        },
        currentPageChange:function(val){
          this.currentPage = val;
        },
        handlePass(index,row){
          this.selectID = row.id;
          this.dialogVisible = true;
          
        },
        handleDelete(index,row){
          this.$confirm('Confirm to delete this person?','Notice',{
            confirmButtonText:'Sure',
            cancelButtonText:'cancle',
            type:'warning',
            center:true
          }).then(()=>{
            this.$axios.delete('/hlsTS/hlsii/admin/deleteRegister/' +  row.id).then(() => {
                this.query();
                this.dialogVisible = false;
                this.$message('Operation successful');
            })
          })
        },
        passEvent(){
          this.$axios.post('/hlsTS/hlsii/admin/addUserByRegister/'+ this.selectID + '/' + this.roleType).then(() => {
              this.query();
              this.dialogVisible = false;
              this.$message('Operation successful');
          })
        }
      }
    }

</script>



// WEBPACK FOOTER //
// src/page/activePublic/userManagement/registerManagement.vue